import { ComplianceCaseTypeEnum } from "~/graphql/supergraphEnums";

export const PEP_EXPOSURE_CASE_TYPES: readonly ComplianceCaseTypeEnum[] = [
  ComplianceCaseTypeEnum.EntityOnboarding,
  ComplianceCaseTypeEnum.ClientOnboarding,
];

export const showsPepExposure = (caseType?: ComplianceCaseTypeEnum | string | null): boolean =>
  !!caseType && PEP_EXPOSURE_CASE_TYPES.includes(caseType as ComplianceCaseTypeEnum);

export const PEP_EXPOSURE_EMPTY_DISPLAY = "--";

export const PEP_CATEGORY_LABELS: Record<number, string> = {
  1: "Category 1",
  2: "Category 2",
  3: "Category 3",
};
